var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loader)?_c('div',[_c('img',{staticClass:"loader",attrs:{"src":require("@/assets/images/loading-icon-driver.png"),"alt":""}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }